import * as React from 'react';
import { map } from 'lodash';
import { SelectOption } from './formData';

interface Props {
    options: SelectOption[];
}

class SelectOptions extends React.Component<Props> {
    render() {
        const { options } = this.props;

        return map(options, (option: SelectOption) => {
            const { id, label } = option;

            return (
                <option
                    key={id}
                    value={id}
                >
                    {label}
                </option>
            );
        });
    }
}

export default SelectOptions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/profile/SelectOptions.tsx